import Vue from 'vue'
import VueIdb from 'vue-idb'

Vue.use(VueIdb)

export default new VueIdb({
  database: 'potly',
  schemas: [
    { pots: 'id, title, author, status, created_at, updated_at' },
    { potDetails: 'id, potId, text, order, status, created_at, updated_at'}
  ],
  options: {
    pots: { type: 'biglist', primary: 'id', label: 'title', updated_at: 'updated_at' },
    potDetails: { type: 'biglist', primary: 'id', label: 'potId', updated_at: 'updated_at' }
  },
})
